import {Message, MessageBox} from 'element-ui'
import auth from '@/utils/auth'
import constants from '@/utils/constants.js'
import {sysTypeGroupByCode} from '@/api/quoteAPI'
export function messageWarning(msg) {
  Message({
    type: 'warning',
    title: '提示',
    message: msg
  })
}

export function messageSuccess(msg) {
  Message({
    type: 'success',
    title: '提示',
    message: msg
  })
}

export function confirm(msg, confirmCallback, cancelCallback, confirmButtonText, cancelButtonText, title) {
  MessageBox.confirm(msg, '提示' || title, {
    confirmButtonText: confirmButtonText || '确定',
    cancelButtonText: cancelButtonText || '取消',
    type: 'warning'
  }).then(() => {
    if (confirmCallback) {
      confirmCallback()
    }
  }).catch(() => {
    if (cancelCallback) {
      cancelCallback()
    }
  })
}

export function isLogin() {
  if (auth.getToken()) {
    return true
  }
  return false
}

export function getUserType() {
  return auth.getUserType()
}

export function isRealname() {
  var type = auth.getUserType()
  return type === '0' || type === '1'
}

export function formatDateTime(dateValue) {
  var date = new Date(dateValue)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  return YY + MM + DD + ' ' + hh + mm + ss
}
export function formatDateTimeForHous(dateValue) {
  var date = new Date(dateValue)
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
  return hh + mm + ss
}
export function formatDate(dateValue) {
  var date = new Date(dateValue)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  return YY + MM + DD
}
export function getSysTypeGroupByCode(code, callback) {
  sysTypeGroupByCode(code).then(res => {
    if (res && res.data && res.data.successful) {
      if (callback) {
        callback(res.data.data.types)
      }
    } else {
      console.log('==============字典项查询失败==============')
    }
  })
}
export function validLoginPwd(pwd) {
  var result = {}
  result.success = false
  var regex1 = /^[\w\W]{6,16}$/
  var regex2 = /(\d+)/
  var regex3 = /([a-zA-Z]+)/
  var regex4 = /([\s]+)/
  if (!regex1.test(pwd) || !regex2.test(pwd) || !regex3.test(pwd) || regex4.test(pwd)) {
    result.msg = '密码格式错误，请输入6-16位字符，至少包含数字、字母'
  } else {
    result.success = true
  }
  return result
}
// 处理html里的转义字符
export function processHtmlSymbol (htmlStr) {
  let div = document.createElement('div')
  div.innerHTML = htmlStr
  return div.innerText || div.textContent
}

const commonUtil = {
  messageWarning,
  messageSuccess,
  confirm,
  isLogin,
  getUserType,
  constants,
  formatDateTime,
  formatDate,
  getSysTypeGroupByCode,
  isRealname,
  validLoginPwd,
  processHtmlSymbol
}

export default commonUtil



// WEBPACK FOOTER //
// ./src/utils/commonUtil.js